import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { dataApi } from "../apis/dataApi";
import '../css/fonts.css'
import '../css/style.css'
import '../css/bootstrap@5.3.0.min.css'
import bg from '../assets/Walpapers/Wallpaper.png';
import logo from '../assets/Logotipo/Logo_cetesninos_color.png';
import logoKZ from '../assets/Logotipo/Logo_KZ.png';
import imagenUrbano from '../assets/Imagenes/Imagen_Urbano.png';
import iconFlecha from '../assets/Iconos/punta-de-flecha.png';
import { useTranslation } from 'react-i18next';



function Inicio() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState('')
  const [selectedRadio, setSelectedRadio] = useState('invest');
  const handleClick = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (code.length > 0 && selectedRadio) {
      dataApi.getToken().then((response) => {
        if (response.isSuccess) {
          dataApi.GetVisitStatus(response.token, code).then((visitorReponse) => {
            console.log(visitorReponse);
            if (visitorReponse.isSuccess) {

              if (visitorReponse.isInLocation === "1") {
                if (selectedRadio === 'invest') {
                  navigate(`/tipo?b=${encodeURIComponent(code)}`);
                } else if (selectedRadio === 'check') {
                  navigate(`/reporte?b=${encodeURIComponent(code)}`);
                }
              } else {
                toast.error('No se encuentra el usuario en la ubicación correcta');
              }
            } else {
              toast.error('Brazalete no encontrado.');
            }
          });
        } else {
          dataApi.getToken().then((responseInner) => {
          });
        }
        console.log(response)
      }).catch();
    } else if (!selectedRadio) {
      toast.error('Seleccione una opción');
    } else {
      toast.error('Ingrese el brazalete ');
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }
  const { t, i18n } = useTranslation();
  var image_urbano = require(`../assets/Imagenes/${t('inicio_imageUrbano')}`)


  return (
    <div
      className="cetes-background no-x-overflow"
      style={{
        backgroundImage: `url(${bg})`,
        minHeight: '100svh',
        height: 'auto',
        overflowX: 'hidden'
      }}
    >
      <div className="cetes_inner_bkg_content" style={{
        minHeight: '100svh',
        height: 'auto',
        overflowX: 'hidden'
      }}>
        <div className="logos_CETES_junior">
          <div
            className="logo left-logo"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}
          >
            <img src={logo} alt="Logo CETES niños" style={{ height: 60, width: 'auto' }} />
            <span style={{ fontSize: 18, whiteSpace: 'nowrap' }}>By KidZania</span>
          </div>
          <div className="logo right-logo">
            <img src={logoKZ} alt="Logo organización KidZania" />
          </div>
        </div>
        <div className="container-wrap-blocks-content">
          <div className="welcome-blocks">
            <div className="welcome-blocks-inner">
              <div className="welcome-info">
                <div className="info-txt-cetesJunior">
                  <div className="title-intro">
                    <h2>{t('inicio_welcome')}</h2>
                  </div>
                  <div className="text-descriptivo">
                    <h4>{t('inicio_dashboard')}</h4>
                  </div>
                </div>
                <div className="welcome-img-movil">
                  <img src={image_urbano} alt="" />
                </div>

                <div className="info-inicio-sesion">
                  <div className="text-descriptivo_left">
                    <p className='radio_sel_class'>{t('inicio_instructions_header')}</p>
                  </div>
                  <div id="operation_options" style={{ marginBottom: '1rem' }}>
                    <label className="radio_sel_class">
                      <input
                        type="radio"
                        name="operation"
                        value="invest"
                        style={{ transform: 'scale(2)' }}
                        checked={selectedRadio === 'invest'}
                        onChange={() => setSelectedRadio('invest')}
                      /> {t('inicio_instructions_op1')}
                    </label>
                    <br />
                    <label className='radio_sel_class'>
                      <input
                        type="radio"
                        name="operation"
                        value="check"
                        style={{ transform: 'scale(2)' }}
                        checked={selectedRadio === 'check'}
                        onChange={() => setSelectedRadio('check')}
                      /> {t('inicio_instructions_op2')}
                    </label>
                  </div>
                  <div className="text-descriptivo">
                    <p>{t('inicio_instructions')}</p>
                  </div>
                  <div className="form-row-cetes-horizontal">
                    <div className="input-txt-cetesJunior">
                      <input 
                        type="text" 
                        name="" 
                        id="txtNumber" 
                        required 
                        onChange={e => setCode(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleClick(e); }}
                      ></input>
                    </div>
                    <div className="btn-cetesJunior btn-icon">
                      <button onClick={handleClick}> <span>Continuar</span>
                        <img src={iconFlecha} alt=""></img>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="welcome-img-desktop">
                <img src={image_urbano} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="loading">
          <div className="spinner"></div>
        </div>
      ) : (
        <div>
          {/* Resto del código */}
        </div>
      )}
    </div>
  );
}

//Funciones varias
function consumirApiInicio() {
  dataApi.getToken().then((response) => {
    if (response.isSuccess) {
      dataApi.getKidByVisitorId(response.token, "63906787-7fc0-45af-9fab-708986a6f9c8").then((responseVisitorId) => {
        console.log(responseVisitorId);
      });
    } else {
      dataApi.getToken().then((responseInner) => {

      });
    }
    console.log(response)


  }).catch();



  /*console.log('consumir api inicio');
  dataApi.getToken().then((token) => {
    dataApi.getKidWithoutCard(token, "7452294102651595").then((resp)=>{

    });
    dataApi.getKidByVisitorId(token, "63906787-7fc0-45af-9fab-708986a6f9c8").then((resp)=>{

    });
    console.log('valor del token en evento del botón:'+token)
  });
  console.log('end consumir api');*/

}
function consumirAPI() {
  const requestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("ss")
  }
  fetch('/', requestInit)
    .then(res => res.text())
    .then(res => console.log(res))
}

export default Inicio;